<template>
    <v-container>
        <v-card class="mx-auto">
            <v-toolbar flat color="secondary">
                <v-toolbar-title>{{ this.$route.meta.title }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                 <v-form
                    ref="form"
                    v-on:submit.prevent="store()"
                    lazy-validation>
                    <v-row>
                            <v-col cols="12">
                            <v-text-field
                            v-model="field.code"
                            :counter="2"
                            :rules="this.rules.not_empty"
                            :disabled="attributeCode"
                            label="Code"
                            required
                            v-focus
                            ></v-text-field>
                            </v-col>

                            <v-col cols="12">
                            <v-text-field
                            v-model="field.name"
                            :counter="50"
                            label="Name"
                            required
                            :rules="this.rules.not_empty"
                            maxlength="50"
                            ></v-text-field>
                            </v-col>

                            <v-col cols="12">
                            <v-select
                            v-model="field.type"
                            :items="field.typeItem"
                            item-value="id"
                            item-text="text"
                            label="Type"
                            dense
                            ></v-select>
                            </v-col>

                            <v-col cols="12">
                            <v-text-field
                            v-model="field.validation"
                            :counter="50"
                            label="Validation"
                            required
                            maxlength="50"
                            ></v-text-field>
                            </v-col>

                            <v-col cols="12">
                                <v-text-field
                                v-model="field.swatch_type"
                                :counter="50"
                                label="Swatch Type"
                                required
                                maxlength="50"
                                ></v-text-field>
                            </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="3">
                            <v-switch v-model="field.is_required" label="Required"></v-switch>
                        </v-col>
                        <v-col cols="3">
                            <v-switch v-model="field.is_unique" label="Unique"></v-switch>
                        </v-col>
                        <v-col cols="3">
                            <v-switch v-model="field.is_filterable" label="Filterable"></v-switch>
                        </v-col>
                        <v-col cols="3">
                            <v-switch v-model="field.is_configurable" label="Configurable"></v-switch>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <v-switch v-model="field.is_user_defined" label="User defined"></v-switch>
                        </v-col>
                        <v-col cols="4">
                            <v-switch v-model="field.is_visible_on_front" label="Visible on front"></v-switch>
                        </v-col>
                        <v-col cols="4">
                            <v-switch v-model="field.use_in_flat" label="Use In Flat"></v-switch>
                        </v-col>
                    </v-row>
                    <v-row v-if="this.$route.name===this.$route.meta.parent+'.edit'">
                        <v-col cols="12">
                            <v-card class="mx-auto">
                                <v-toolbar flat color="secondary" >
                                    <v-toolbar-title>Attribute Option</v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-dialog v-model="dialog" max-width="600px">
                                    <template v-slot:activator="{ on }">
                                        <v-btn color="deep-orange accent-3" v-on="on" ><v-icon left>{{icon.add}}</v-icon>Add</v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                        <span class="headline">{{ formTitle }}</span>
                                        </v-card-title>
                                        <v-card-text>
                                        <v-container>
                                            <v-row>
                                            <v-col cols="12">
                                                <v-text-field v-model="editedOption.code" label="Code*" required :disabled="codeOption"></v-text-field>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-text-field label="Name*" v-model="editedOption.name"></v-text-field>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-text-field label="COGS" v-model="editedOption.default_cogs"></v-text-field>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-text-field label="Swatch value" v-model="editedOption.swatch_value"></v-text-field>
                                            </v-col>
                                            <v-col cols="12">
                                                <v-text-field label="Sort Order" v-model="editedOption.sort_order"></v-text-field>
                                            </v-col>
                                            </v-row>
                                        </v-container>
                                        </v-card-text>
                                        <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="closeOption">Close</v-btn>
                                        <v-btn color="blue darken-1" text @click="saveOption">Save</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                    </v-dialog>
                                </v-toolbar>
                                <v-card-text elevation="2">
                                    <v-simple-table>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-center">Code</th>
                                                    <th class="text-left">Name</th>
                                                    <th class="text-right">COGS</th>
                                                    <th class="text-left">Swatch Value</th>
                                                    <th class="text-left">Sort Order</th>
                                                    <th class="text-left">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in field.option" :key="item.code">
                                                    <td class="text-center">{{item.code}}</td>
                                                    <td class="text-left">{{item.name}}</td>
                                                    <td class="text-right">{{item.default_cogs}}</td>
                                                    <td class="text-left">{{item.swatch_value}}</td>
                                                    <td class="text-left">{{item.sort_order}}</td>
                                                    <td>
                                                        <v-icon
                                                            small
                                                            class="mr-2"
                                                            @click="editOption(item)"
                                                        >
                                                            {{icon.edit}}
                                                        </v-icon>
                                                        <!-- <v-icon
                                                            small
                                                            @click="deleteOption(item)"
                                                        >
                                                            {{icon.delete}}
                                                        </v-icon> -->
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <h1>Translation</h1>
                        </v-col>
                    </v-row>
                    <v-skeleton-loader
                    :loading="loadingSkeleton"
                    :elevation="6"
                    height="94"
                    type="list-item"
                    >
                    <v-expansion-panels v-model="panel" multiple>
                        <v-expansion-panel v-for="(lang, index) in langs" :key="index">
                            <v-expansion-panel-header class="subtitle-2">{{ lang.name }}</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-row>
                                    <v-col cols="12">
                                        <v-text-field
                                        v-model="field.translation.trans_name[index]"
                                        :counter="50"
                                        :rules="rules.not_empty"
                                        label="Name"
                                        required
                                        maxlength="50"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                    </v-skeleton-loader>
                    <v-row>
                        <v-col>
                            <v-card-actions>
                                <v-btn @click="btnBack"
                                color="grey lighten-5" type="button"><v-icon left>{{icon.back}}</v-icon>Back</v-btn>
                                <v-btn 
                                :disabled="loading"
                                color="primary" type="submit" class="float-right"><v-icon left>{{icon.save}}</v-icon>Simpan</v-btn>
                            </v-card-actions>
                        </v-col>
                    </v-row>
                 </v-form>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
/* eslint-disable */
    import rules from "@/plugins/validation_rules.js";
    let context;

    let field = {
        code:"",
        name:"",
        swatch_type:"",
        is_required: 1,
        is_unique: 1,
        is_filterable: 1,
        is_configurable: 0,
        is_user_defined: 0,
        is_visible_on_front: 1,
        use_in_flat: 1,
        type: "Radio",
        typeItem:[
            {
                id:"Radio",
                text: "Radio"
            },
            {
                id:"Checkbox",
                text: "Checkbox"
            },
            {
                id:"Select",
                text: "Select"
            },
            {
                id:"Input",
                text: "Input"
            }
        ],
        translation:
        {
            trans_locale: [],
            trans_name: []
        },
        option:[],
        
    }
    export default{
        name: "attributes.add",
        data:()=>{
            return{
                attributeCode:false,
                codeOption: false,
                dialog: false,
                expandTranslation: false,
                panel: [],
                loadingSkeleton: true,
                langs:[],
                edit:false,
                loading:false,
                show:false,
                rules:rules,
                editedIndex: -1,
                attribute_id: 0,
                icon:{
                    add:'mdi-plus',
                    edit:'mdi-pencil',
                    delete:'mdi-delete',
                    save:"mdi-check-bold",
                    back:"mdi-arrow-left"
                },
                field: field,
                editedOption: {
                    attribute_id:'',
                    id: '',
                    code: '',
                    name: '',
                    default_cogs: '',
                    swatch_value: '',
                    sort_order: '',
                },
                defaultOption: {
                    attribute_id: '',
                    id: '',
                    code: '',
                    name: '',
                    default_cogs: '',
                    swatch_value: '',
                    sort_order: '',
                },
            }
        },
        computed: {
            formTitle (){
                return this.editedIndex === -1 ? 'Add Attribute Option' : 'Edit Attribute Option'
            }
        },
        watch: {
            dialog (val) {
                val || this.closeOption()
            }
        },
        methods:{
            btnBack () {
                this.$router.go(-1);
            },
            resetDefault(){
                context.field.code = '';
                context.field.name = '';
                context.field.swatch_type="";
                context.field.is_required= 1;
                context.field.is_unique= 1;
                context.field.is_filterable= 1;
                context.field.is_configurable= 0;
                context.field.is_user_defined= 0;
                context.field.is_visible_on_front= 1;
                context.field.use_in_flat= 1;
                context.field.type= "Radio";
                context.field.translation.trans_name = [];
            },
            translationCheck () {
                if(!context.expandTranslation) context.expand();
                let checked = true;
                context.field.translation.trans_locale.forEach((value, k) => {
                        // alert(this.field.translation.trans_name[k])
                    if(this.field.translation.trans_name[k] == ''){
                        checked = false;
                        // alert(this.field.translation.trans_name[k])
                    }
                });
                return checked;
                
            },
            expand () {
                context.panel = [...Array(context.langs.length).keys()].map((k, i) => i)
                context.expandTranslation = true;
            },
            store:async ()=>{
                if(context.$refs.form.validate()){
                     
                    if(context.translationCheck()){
                    context.loading=true;
                    let payload=context.field;

                    let uri;
                    let success_text;
                    
                    if(!context.edit){
                        await context.$http
                        .post(context.$route.meta.parent+'/store',payload)
                        .then(response=>{
                            if(response.status===200){
                                context.$notify({
                                    group:"success",
                                    title:"Success Notification",
                                    text:"Berhasil menambahkan "+payload.name+" ke database"
                                })
                                // context.$refs.form.reset();
                                // context.resetDefault();
                                context.$router.push('/'+context.$route.meta.parent)
                            }
                        })
                        .catch(err=>{
                            context.$notify({
                                group:"error",
                                title:"Error Notification",
                                text:"Terjadi kesalahan pada client"
                            })
                        });
                    }else{
                        payload.id=context.$route.params.id;
                        await context.$http
                        .patch(context.$route.meta.parent+'/update',payload)
                        .then(response=>{
                            if(response.status===200){
                                context.$notify({
                                    group:"success",
                                    title:"Success Notification",
                                    text:"Berhasil merubah "+payload.name
                                })
                                context.$router.push('/'+context.$route.meta.parent)
                            }
                        })
                        .catch(err=>{
                            context.$notify({
                                group:"error",
                                title:"Error Notification",
                                text:"Terjadi kesalahan pada client"
                            })
                        });
                    }
                    
                    context.loading=false;
                    }
                    
                }                
            },
            editOption (item) {
                context.editedIndex = context.field.option.indexOf(item)
                context.editedOption = Object.assign({}, item)
                context.dialog = true;
                context.codeOption = true;
                // console.log(context.editedOption)
                // alert(item.name)
            },
            closeOption () {
                context.dialog = false;
                context.codeOption = false;
                setTimeout (() => {
                    context.editedOption = Object.assign({}, context.defaultOption)
                    context.editedIndex = -1
                }, 300)
            },
            async saveOption () {
                let payload=context.editedOption;
                let act = 'add';
                if(context.editedIndex === -1){ 
                    act = 'store'; 
                    await context.$http.post('/attributeoptions/'+act+'?attribute_id='+context.attribute_id,payload).then(response=>{
                        
                        if(context.editedIndex > -1){
                            Object.assign(context.field.option[context.editedIndex], context.editedOption)
                        }else{
                            context.field.option.push(context.editedOption)
                        }
                        context.closeOption()
                    })
                }else{ 
                    act = 'update'; 
                    await context.$http.patch('/attributeoptions/'+act+'?attribute_id='+context.attribute_id,payload).then(response=>{
                        
                        if(context.editedIndex > -1){
                            Object.assign(context.field.option[context.editedIndex], context.editedOption)
                        }else{
                            context.field.option.push(context.editedOption)
                        }
                        context.closeOption()
                    })

                } 

                
            },
            deleteOption (item) {
                const index = context.field.option.indexOf(item)
                // alert(index)
                confirm('Apakah Anda Yakin?') && context.field.option.splice(index, 1)
            },
        },
        async mounted(){
            context=this;
            // this.langs.forEach((value) => {
            //     this.names.push(value.code);
            //     this.names[value.code] = value.name;
            // });
            // context.names.push("id");
            await context.$http.get('locales/get').then((response)=>{
                this.langs = response.data.data;
                this.loadingSkeleton = false;
                response.data.data.forEach((value) => {
                    this.field.translation.trans_locale.push(value.code);
                });
                context.expand();
            }).catch(err=>{
                console.log(err)
            })
            if(context.$route.name===context.$route.meta.parent+".edit"){
                context.edit=true;
                context.attribute_id = context.$route.params.id;
                context.attributeCode = true;
                await context.$http
                .get(context.$route.meta.parent+'/get?id='+context.$route.params.id)
                .then(response=>{
                    let data=response.data.data;
                    // console.log(data)
                    if(data!=null){
                        let attr = data.attribute;
                        context.field.code=attr.code;
                        context.field.name=attr.name;
                        context.field.type=attr.type;
                        context.field.validation=attr.validation;
                        context.field.swatch_type=attr.swatch_type;
                        context.field.is_required=attr.is_required;
                        context.field.is_unique=attr.is_unique;
                        context.field.is_filterable=attr.is_filterable;
                        context.field.is_configurable=attr.is_configurable;
                        context.field.is_user_defined=attr.is_user_defined;
                        context.field.is_visible_on_front=attr.is_visible_on_front;
                        context.field.user_in_flat=attr.user_in_flat;
                        
                        let trans = data.translation;
                        
                        trans.forEach((value) => {
                            this.field.translation.trans_name.push(value.name)
                        })

                        let option = data.option;
                        context.field.option = option;
                    }else{
                        context.$router.push("/"+context.$route.meta.parent);
                    }
                })
                .catch(err=>{

                })
            }
        }
    }
</script>